<script setup lang="ts">
import { computed } from "vue";

import { useTheme } from "@/layout/composables/theme.ts";

const { isDark } = useTheme();

const themeIcon = computed(() => (isDark.value ? "pi pi-moon" : "pi pi-sun"));
</script>

<template>
  <Button v-model="isDark" :icon="themeIcon" variant="text" @click="isDark = !isDark" />
</template>
